<template>
  <div class="container">
    <div class="row">

      <div class="col-12 text-center" style="font-size: 1.4em; ">
        Peamoni, c’est l’idée saugrenue de créer un outil pour gérer son PEA, 
        <br>avec une interface accueillante et conviviale.
        <br>Pari difficile quand il s’agit de manipuler essentiellement des données et des graphiques techniques. 
        <br><span class="text-primary">Pas de soucis, notre équipe de choc relève le défi !</span>
      </div>

      <div class="col-lg-3 col-md-6 col-12 ml-auto mr-auto">
        <card class="card-lock text-center">
          <img slot="header" src="img/mike.jpg" alt="..." />
          <h4 class="card-title">Olivier<br><small class="text-primary">Passioné des marchés</small></h4>
          <div>
            Depuis plus de 12 ans, Olivier parcours les marchés (financiers hein!) pour trouver les bonnes affaires et apporte son expertise au projet.
          </div>
        </card>
      </div>

      <div class="col-lg-3 col-md-6 col-12 ml-auto mr-auto">
        <card class="card-lock text-center">
          <img slot="header" src="img/james.jpg" alt="..." />
          <h4 class="card-title">Vivien<br><small class="text-primary">Au service des utilisateurs</small></h4>
          <div>
            Développeur confirmé, Vivien aime particulièrement le contact des utilisateurs, pour créer des fonctionnalités "qui claquent", selon ses dires.
          </div>
        </card>
      </div>

      <div class="col-lg-3 col-md-6 col-12 ml-auto mr-auto">
        <card class="card-lock text-center">
          <img slot="header" src="img/lora.jpg" alt="..." />
          <h4 class="card-title">Cindy<br><small class="text-primary">Du design au dév</small></h4>
          <div>
            Concevoir de belles IHM, les développer, les tester et surtout soigner l'expérience utilisateur, c'est son job et elle le fait super bien. 
          </div>
        </card>
      </div>

      <div class="col-lg-3 col-md-6 col-12 ml-auto mr-auto">
        <card class="card-lock text-center">
          <img slot="header" src="img/robi.jpg" alt="..." />
          <h4 class="card-title">Bilal<br><small class="text-primary">Mangeur de données</small></h4>
          <div>
            ... ou data scientist, comme vous voulez. Bilal expérimente des nouvelles technos d'IA pour faire ressortir des données essentielles pour les utilisateurs. 
          </div>
        </card>
      </div>

      <div class="col-12 mt-3 text-center">
        <small>
        Comme beaucoup de site de startup, ce ne sont pas nos vrais photos.
        <br>Nous somme bien trop laids pour gâcher cette page web 😅
        </small>
      </div>


    </div>
  </div>
</template>
<script>
export default {
  components: {
  }
};
</script>
<style></style>
